import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Tables } from "@/types/database.types";
import { inboxService } from "@/services/inboxService";
import { Conversation } from "@/pages/Inbox";

export type ConversationSummary = Conversation;

export function useAgentConversations(agentId: string | undefined) {
  const [conversations, setConversations] = useState<ConversationSummary[]>([]);
  const [count, setCount] = useState<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      if (!agentId) {
        setIsLoading(false);
        return;
      }

      setIsLoading(true);
      setError(null);

      try {
        // Use the inbox service to fetch agent-specific conversations
        const {
          data,
          error: fetchError,
          count: conversationCount,
        } = await inboxService.getAgentConversations(agentId);

        if (fetchError) throw fetchError;

        setCount(conversationCount);
        setConversations(data || []);

        console.log(
          `[DEBUG] Fetched ${
            data?.length || 0
          } conversations for agent ${agentId}`
        );
      } catch (err: any) {
        console.error("Error fetching agent conversations:", err);
        setError(err.message || "Failed to load conversations");
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [agentId]);

  return { conversations, count, isLoading, error };
}
